import React, { useState, useEffect } from "react";
import {
    Alert,
    Button,
    ButtonGroup,
    Container,
    Card,
    Col,
    Form,
    Row,
    Modal,
    Spinner,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";

import { getOrgs } from "../../../redux/organization/actions";
// import { getEmployees,getGlobalEmployees } from "../../../redux/employees/actions";
import messages from "../../../redux/messages";
import SidebarConfig from "../../../components/Clima/SidebarClimate";
import CustomPagint from "../../../components/CustomPagint";
import { deleteNotificationSegment, getNotificationSegment } from "../../../redux/moduloNotificaciones/segmentoNotificacion/actions";
import SegmentModal from "../../../components/Modulo_Notificaciones/Segmento/SegmentModal";
import SidebarModuloNotificaciones from "../../../components/Modulo_Notificaciones/SidebarModuloNotificaciones";
import moment from "moment";

const SegmentoNotificacion = (props) => {
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [edit, setEdit] = useState(false);
    const [index, setIndex] = useState(0);
    const [editItem, setEditItem] = useState({});
    const [viewItem, setViewItem] = useState({});
    const [showFormModal, setShowFormModal] = useState(false);
    const [showModalVisualization, setShowModalVisualization] = useState(false);
    const [filter, setFilter] = useState("");
    // const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);
    const userRoles = useSelector((store) => store.auth.userRoles);

    const [employeeSubmit, setEmployeeSubmit] = useState(false);
    const dispatch = useDispatch();

    const {
        loading,
        notificationSegmentsLength,
        notificationSegments
    } = useSelector((store) => store.notificationSegment);
    const pages = Math.ceil(notificationSegmentsLength / limit);

    const [employeeListSelected, setEmployeeListSelected] = useState([]);

    const columns = [
        {
            Header: "Segmento",
            accessor: "nombre",
            Filter: ""
        },
        {
            Header: "Fecha de creación",
            accesor: "fecha_creacion",
            Filter: "",
            Cell: (value) => (
                <div>
                    {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <div className="btn-group" role="group">

                    <OverlayTrigger
                        placement="auto"
                        overlay={<Tooltip {...props}>Editar</Tooltip>}
                    >
                        <Button
                            size="sm"
                            variant="link"
                            type="button"
                            onClick={() => onEdit(value.row.original, value.row.index)}
                        >
                            <i className="material-icons">edit</i>
                        </Button>
                    </OverlayTrigger>
                    {userRoles.length > 0 && userRoles.includes("administrador") ? (
                        <OverlayTrigger
                            placement="auto"
                            overlay={<Tooltip {...props}>eliminar</Tooltip>}
                        >
                            <Button
                                size="sm"
                                className="text-danger"
                                variant="link"
                                type="button"
                                onClick={() => onDelete(value.row.original.id, value.row.index)}
                            >
                                <i className="material-icons">close</i>
                            </Button>
                        </OverlayTrigger>
                    ) : null}
                </div>
            ),
        },
    ];

    // Métodos
    const getASegment = (offs = offset, lim = limit, filt = filter) =>
        dispatch(
            getNotificationSegment({
                offset: offs,
                limit: lim,
                filter: filt,
                tipo_busqueda: "nombre"
            })
        );

    useEffect(() => {
        getASegment();
        dispatch(getOrgs(2));
        setEmployeeSubmit(false);
    }, []);

    const onAdd = () => {
        setEmployeeSubmit(false);
        setEmployeeListSelected([]);
        setShowFormModal(true);
        setEdit(false);
        // setValidated(false);
    };

    const onEdit = (item, index) => {
        if (item.empleados_list) {
            setEmployeeListSelected(item.empleados_list);
        } else {
            setEmployeeListSelected([]);
        }

        setEmployeeSubmit(false);
        setIndex(index);
        setEdit(true);
        setEditItem(item);
        // setShowModal(true);
        setShowFormModal(true);
        // setValidated(false);
    };

    const onView = (item, index) => {
        setViewItem(item);
        setShowModalVisualization(true);
    };

    const onSearch = (e) => {
        e.preventDefault();
        setFilter(e.target.filter.value);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getASegment(oOffset, limit, e.target.filter.value);
    };

    const seeAll = () => {
        const oSearch = "";
        setFilter(oSearch);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getASegment(oOffset, limit, oSearch);
    };

    const onDelete = (id, index) => {
        if (window.confirm(messages.preguntaEliminar)) {
            dispatch(deleteNotificationSegment(id, index));
            window.alert("Se borro este archivo");
        }
    };

    const onShowSidebar = () => setShow(show ? false : true);

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarModuloNotificaciones show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                        <h6 className="font-weight-bold text-uppercase">Segmento</h6>
                        <Form onSubmit={onSearch}>
                            <Row className="justify-content-end align-items-center flex-nowrap">
                                <Col xs="auto">
                                    <Form.Control
                                        name="filter"
                                        id="filter"
                                        placeholder="Buscar"
                                        className="rounded-pill form-control-sm"
                                        type="search"
                                    ></Form.Control>
                                </Col>
                                <Col xs="auto">
                                    <ButtonGroup>
                                        <Button
                                            onClick={() => seeAll()}
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle mr-2"
                                        >
                                            <i className="material-icons">list</i>
                                        </Button>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle"
                                            onClick={() => onAdd()}
                                        >
                                            <i className="material-icons">add</i>
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : (
                        notificationSegmentsLength > 0 && (
                            <>
                                <Card className="border-0">
                                    <Card.Body className="px-1 px-sm-2">
                                        <CustomTable columns={columns} data={notificationSegments} />
                                    </Card.Body>
                                </Card>
                                <CustomPagint
                                    limit={limit}
                                    setLimit={setLimit}
                                    offset={offset}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    dataLenght={notificationSegmentsLength}
                                    pages={pages}
                                    pagFunc={getASegment}
                                />
                            </>
                        )
                    )}
                    {notificationSegmentsLength === 0 && (
                        <Alert variant="info" className="my-4">
                            Aún no hay segmentos, comienza agregando algunos
                        </Alert>
                    )}
                </Container>
            </div>

            <SegmentModal
                showFormModal={showFormModal}
                setShowFormModal={setShowFormModal}
                edit={edit}
                editItem={editItem}
                index={index}
                maintenance={true}
            />
        </>
    );
};

export default SegmentoNotificacion;
